



import EnterpriseService from '@/services/enterprise/EnterpriseService';
import Vue from 'vue';

export default Vue.extend({
  data: () => ({
    enterpriseService: new EnterpriseService(),
  }),

  mounted() {
    const operationRequestId = this.$route.query.request;
    const { token } = this.$route.query;

    this.enterpriseService.confirmOperationRequest(operationRequestId, token).then(() => {
      this.$store.commit('errorMessage', 'Administrator added.');
      this.$router.push('/administrators');
    }, (error) => {
      if (error.response.status === 403) {
        this.$store.commit('errorMessage', 'Request code invalid.');
        this.$router.push('/administrators');
      } else if (error.response.status === 404) {
        this.$store.commit('errorMessage', 'Request already fulfulled.');
        this.$router.push('/administrators');
      }
    });
  },
});
